// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/DroidSans-Bold-webfont.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/DroidSans-webfont.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Abril+Fatface&family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "droid_sansbold";
  src: local("DroidSans-Bold-webfont.ttf"), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "droid_sansregular";
  src: local("DroidSans-webfont.ttf"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
*,
*::before,
*::after {
  box-sizing: border-box;
}

* {
  margin: 0;
  padding: 0;
}

ul[role=list],
ol[role=list] {
  list-style: none;
}

html:focus-within {
  scroll-behavior: smooth;
}

a:not([class]) {
  text-decoration-skip-ink: auto;
}

img,
picture,
svg,
video,
canvas {
  max-width: 100%;
  height: auto;
  vertical-align: middle;
  font-style: italic;
  background-repeat: no-repeat;
  background-size: cover;
}

input,
button,
textarea,
select {
  font: inherit;
}

@media (prefers-reduced-motion: reduce) {
  html:focus-within {
    scroll-behavior: auto;
  }
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
    transition: none;
  }
}
body,
html {
  height: 100%;
  scroll-behavior: smooth;
}

body {
  font-family: "Poppins", sans-serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  margin: 0;
  padding: 0;
  background-color: #f4f6fa;
  color: #2f2f2f;
  font-size: 0.875rem;
  --bs-body-font-size: 0.875rem;
  line-height: 22px;
}

button:disabled,
input:disabled,
textarea:disabled,
select:disabled {
  cursor: not-allowed !important;
  opacity: 0.6 !important;
}

p {
  font-family: "Poppins", sans-serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
  line-height: 1.25;
  color: #2f2f2f;
  margin-bottom: 1rem;
}

table {
  border: 1px solid #ebebeb;
  border-radius: 0.5rem;
  font-family: "Poppins", sans-serif;
  font-size: 0.875rem;
  color: #151515;
}

table thead {
  font-family: "Poppins", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
  border-radius: 8px 8px 0 0;
}

table tr td,
table tr th {
  text-align: center;
  padding: 0.6rem 0.5rem !important;
  vertical-align: middle;
}

fieldset,
legend {
  all: revert;
  border-radius: 6px;
  border-color: #bfbfbf;
  background-color: #f5f7fb;
  border-width: 1px;
  padding: 0;
}

legend {
  font-family: "Poppins", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
  background-color: transparent;
  color: #0d47a0;
  font-size: 1rem;
  margin-left: 10px;
  padding: 0 3px;
}

input[type=checkbox] {
  border: 1px solid #949494;
  width: 18px;
  height: 18px;
}

.success-color {
  background-color: #339900;
  color: #fff;
  padding: 0 3px;
  border-radius: 3px;
}

.warning-color {
  background-color: #ed8b00;
  color: #fff;
  padding: 0 3px;
  border-radius: 3px;
}

.danger-color {
  background-color: #cc3201;
  color: #fff;
  padding: 0 3px;
  border-radius: 3px;
}

.form-control:focus {
  border-color: #9fa7b7;
  box-shadow: none;
}

.btn {
  font-family: "Poppins", sans-serif !important;
  font-size: 14px !important;
  font-weight: 600 !important;
}

.btn.btn-primary,
.btn:active.btn-primary,
.btn.active.btn-primary {
  background-color: #0d47a0;
}

.btn.btn-primary:hover {
  background-color: #093373;
}

.form-select {
  font-family: "Poppons", sans-serif !important;
  font-size: 14px !important;
  line-height: 22px !important;
}

.form-label {
  margin-bottom: 0.325rem;
  font-size: 14px;
  line-height: 18px;
}

.form-control {
  border: 1px solid #e0e3e8;
  width: 100%;
  max-width: 250px;
  height: 48px;
  border-radius: 6px;
  font-size: 14px;
  line-height: 22px;
  padding: 10px 12px;
}

.form-control.login-input-form {
  max-width: 380px;
}

.form-select {
  width: 100%;
  max-width: 358px;
}

.red-border {
  border-color: red !important;
  border: 1px solid red !important;
  color: red !important;
}

.green-border {
  border-color: green !important;
  border: 1px solid green !important;
  color: green !important;
}

.btn-primary {
  background-color: #0d47a0;
  font-weight: bold;
  transition: all 0.3s ease-in-out;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  white-space: nowrap;
}
.btn-primary:hover {
  background-color: #093373;
}

.page-title {
  font-family: "Abril Fatface", serif;
  font-weight: 400;
  font-style: normal;
  font-size: 2rem;
  color: #0d47a0;
  line-height: 2.5rem;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.Select-input {
  width: 330px;
  height: 46px;
  padding: 8px 12px;
  border-radius: 0.5rem;
  border: 1px solid #d3d3d3;
  appearance: none;
  background-image: linear-gradient(45deg, transparent 50%, gray 50%), linear-gradient(135deg, gray 50%, transparent 50%), linear-gradient(to right, #ccc, #ccc);
  background-position: calc(100% - 20px) calc(1em + 6px), calc(100% - 15px) calc(1em + 6px), calc(100% - 2.5em) 0.9em;
  background-size: 5px 5px, 5px 5px, 1px 1.5em;
  background-repeat: no-repeat;
}

.footer-button {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-top: 24px;
  gap: 1rem;
}

.graph-title {
  font-family: "Poppins", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
  font-size: 0.875rem;
  color: #2f2f2f;
  padding: 0 1rem 1rem;
  display: flex;
  justify-content: center;
}

.table-responsive {
  max-height: calc(100vh - 150px);
  overflow: auto;
}
.table-responsive thead {
  position: sticky;
  top: -1px;
  margin: 0 0 0 0;
  z-index: 2;
}
.table-responsive thead th {
  background-color: #f2f5f7;
}

.export-btn {
  display: flex;
  white-space: nowrap;
}

.export-share-btn-group {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: flex-end;
}

.apexcharts-tooltip-title {
  font-family: "Poppins", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
}

.childrenContainer {
  display: block;
  padding: 0;
  margin: 0;
}

#tooltip-top > .tooltip-inner {
  font-family: "Poppins", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
  font-size: 0.875rem;
  background: rgb(9, 51, 115);
  color: #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

.tooltip-container {
  --bs-tooltip-bg: \$primary-color;
  --bs-emphasis-color: \$primary-color;
  --bs-tooltip-opacity: 1;
}

.pagination-container {
  display: flex;
  align-items: baseline;
  justify-content: flex-end;
  margin-top: 1rem;
}

.page-link.active,
.active > .page-link {
  font-family: "Poppins", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
  background-color: #0d47a0;
  font-size: 0.875rem;
}

.page-link {
  font-family: "Poppins", sans-serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
  color: #0d47a0;
}

Table thead {
  position: sticky;
  top: 0px;
  margin: 0 0 0 0;
}

.blue-color {
  border-left: 3px solid #0d6efd;
}

.green-color {
  border-left: 3px solid #008085;
}

.purple-color {
  border-left: 3px solid #7952b3;
}

.orange-color {
  border-left: 3px solid #ff8225;
}

.c-pointer {
  cursor: pointer !important;
}

.error-text {
  color: red;
  font-size: 13px;
  line-height: 1.2;
  animation: showErrors 0.5s ease-in-out;
}

@keyframes showErrors {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.error-border {
  border-color: #cc3201;
  animation: horizontal-shaking 0.35s ease;
}

@keyframes horizontal-shaking {
  0% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(5px);
  }
  50% {
    transform: translateX(-5px);
  }
  75% {
    transform: translateX(5px);
  }
  100% {
    transform: translateX(0);
  }
}
.form-input {
  border: 1px solid #c2c2c2;
  box-shadow: none;
  padding: 10px 4px;
  border-radius: 6px;
  width: 100px;
}

.modal-body {
  overflow-x: auto;
}

@media (max-width: 767px) {
  .form-label {
    width: 150px;
    white-space: nowrap;
  }
}
@media (min-width: 768px) and (max-width: 1180px) {
  .form-label {
    width: 150px;
    white-space: nowrap;
  }
}
.loader-container-sm {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
}

.loader-sm {
  width: 24px;
  height: 24px;
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: #000;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.loader-color-white {
  border: 4px solid rgba(255, 255, 255, 0.1);
  border-left-color: #fff;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.loader-text {
  margin-left: 10px;
  font-size: 14px;
}

.legend {
  display: flex;
  gap: 2rem;
  flex-flow: row wrap;
  margin-bottom: 0.5rem;
  padding-left: 0;
}

.legend li {
  padding-left: 1.5rem;
  display: block;
  position: relative;
}

.legend li:nth-child(1)::before {
  content: "";
  width: 16px;
  height: 16px;
  background-color: #2a61dd;
  position: absolute;
  border-radius: 50%;
  top: 15%;
  left: 0;
}

.legend li:nth-child(2)::before {
  content: "";
  width: 16px;
  height: 16px;
  background-color: #279e70;
  position: absolute;
  border-radius: 50%;
  top: 15%;
  left: 0;
}

.legend li:nth-child(3)::before {
  content: "";
  width: 16px;
  height: 16px;
  background-color: #ff9800;
  position: absolute;
  border-radius: 50%;
  top: 15%;
  left: 0;
}

.legend li:nth-child(4)::before {
  content: "";
  width: 16px;
  height: 16px;
  background-color: #c82519;
  position: absolute;
  border-radius: 50%;
  top: 15%;
  left: 0;
}

.actionITems {
  display: block;
}
.actionITems .action-item-icon {
  cursor: pointer;
  font-size: 22px;
  color: #2f2f2f;
  padding: 3px;
}
.actionITems .action-item-icon:hover {
  color: #cc3201;
}

.thead-align {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.sticky-col {
  position: sticky;
  left: 0;
  background-color: #fff;
  z-index: 1;
  width: 150px;
}

.sticky-col:nth-child(2) {
  left: 150px; /* Adjust width as needed */
}

.sticky-col:nth-child(3) {
  left: 300px; /* Adjust width as needed */
}

.btn-text {
  font-family: "Poppins", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
  display: inline;
  font-size: 0.825rem;
  color: #0d47a0;
  text-decoration: underline;
  cursor: pointer;
}

.success-message {
  font-family: "Poppins", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
  display: flex;
  color: #339900;
  padding: 6px 12px;
  background-color: #fff;
  border: 1px solid #339900;
  border-radius: 6px;
  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
}
.success-message h4 {
  margin-bottom: 0;
}

.error-message {
  font-family: "Poppins", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
  display: flex;
  color: #cc3201;
  padding: 6px 12px;
  background-color: #fff;
  border: 1px solid #cc3201;
  border-radius: 6px;
  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
}

.close-button {
  font-family: "Poppins", sans-serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
  background-color: #333;
  padding: 4px 6px;
  color: #fff;
  font-size: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/mixins/fonts.scss","webpack://./src/App.scss","webpack://./src/assets/mixins/reset.scss","webpack://./src/assets/mixins/colors.scss","webpack://./src/assets/mixins/mixins.scss"],"names":[],"mappings":"AAEA;EACE,6BAAA;EACA,oGAAA;EAEA,mBAAA;EACA,kBAAA;ACAF;ADEA;EACE,gCAAA;EACA,+FAAA;EAEA,mBAAA;EACA,kBAAA;ACDF;ACbA;;;EAGE,sBAAA;ADeF;;ACZA;EACE,SAAA;EACA,UAAA;ADeF;;ACZA;;EAEE,gBAAA;ADeF;;ACZA;EACE,uBAAA;ADeF;;ACZA;EACE,8BAAA;ADeF;;ACZA;;;;;EAKE,eAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,4BAAA;EACA,sBAAA;ADeF;;ACZA;;;;EAIE,aAAA;ADeF;;ACZA;EACE;IACE,qBAAA;EDeF;ECbA;;;IAGE,qCAAA;IACA,uCAAA;IACA,sCAAA;IACA,gCAAA;IACA,gBAAA;EDeF;AACF;ACZA;;EAEE,YAAA;EACA,uBAAA;ADcF;;AA1EA;EDoBE,kCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;ECrBA,mCAAA;EACA,SAAA;EACA,UAAA;EACA,yBEJiB;EFKjB,cEHW;EFIX,mBAAA;EACA,6BAAA;EACA,iBAAA;AAgFF;;AA9EA;;;;EAIE,8BAAA;EACA,uBAAA;AAiFF;;AA/EA;EDEE,kCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;ECHA,iBAAA;EACA,cElBW;EFmBX,mBAAA;AAqFF;;AAnFA;EACE,yBAAA;EACA,qBAAA;EACA,kCAAA;EACA,mBAAA;EACA,cAAA;AAsFF;;AApFA;EDLE,kCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;ECIA,0BAAA;AA0FF;;AAxFA;;EAEE,kBAAA;EACA,iCAAA;EACA,sBAAA;AA2FF;;AAzFA;;EAEE,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,yBAAA;EACA,iBAAA;EACA,UAAA;AA4FF;;AA1FA;EDxBE,kCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;ECuBA,6BAAA;EACA,cEvDc;EFwDd,eAAA;EACA,iBAAA;EACA,cAAA;AAgGF;;AA9FA;EACE,yBAAA;EACA,WAAA;EACA,YAAA;AAiGF;;AA/FA;EACE,yBEtDa;EFuDb,WE/DM;EFgEN,cAAA;EACA,kBAAA;AAkGF;;AAhGA;EACE,yBE9Da;EF+Db,WErEM;EFsEN,cAAA;EACA,kBAAA;AAmGF;;AAjGA;EACE,yBEnEY;EFoEZ,WE3EM;EF4EN,cAAA;EACA,kBAAA;AAoGF;;AAhGA;EACE,qBAAA;EACA,gBAAA;AAmGF;;AAjGA;EACE,6CAAA;EACA,0BAAA;EACA,2BAAA;AAoGF;;AAlGA;;;EAGE,yBEjGc;AFsMhB;;AAlGA;EACE,yBEpGoB;AFyMtB;;AAnGA;EACE,6CAAA;EACA,0BAAA;EACA,4BAAA;AAsGF;;AApGA;EACE,uBAAA;EACA,eAAA;EACA,iBAAA;AAuGF;;AArGA;EACE,yBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAwGF;;AAtGA;EACE,gBAAA;AAyGF;;AAvGA;EACE,WAAA;EACA,gBAAA;AA0GF;;AAxGA;EACE,4BAAA;EACA,gCAAA;EACA,qBAAA;AA2GF;;AAxGA;EACE,8BAAA;EACA,kCAAA;EACA,uBAAA;AA2GF;;AAxGA;EACE,yBE/Ic;EFgJd,iBAAA;EACA,gCAAA;EACA,mBAAA;EACA,sBAAA;EACA,mBAAA;AA2GF;AA1GE;EACE,yBErJkB;AFiQtB;;AAzGA;EDxIE,mCAAA;EACA,gBAAA;EACA,kBAAA;EIHA,eAAA;EACA,cDjBc;ECkBd,mBAAA;EACA,kBAAA;EACA,qBAAA;AHyPF;;AAjHA;EACE,YAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,yBAAA;EAGA,gBAAA;EACA,8JAAA;EAGA,mHAAA;EAEA,4CAAA;EACA,4BAAA;AAiHF;;AA9GA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,gBAAA;EACA,SAAA;AAiHF;;AA/GA;EDzJE,kCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;ECwJA,mBAAA;EACA,cEnLW;EFoLX,oBAAA;EACA,aAAA;EACA,uBAAA;AAqHF;;AAnHA;EACE,+BAAA;EACA,cAAA;AAsHF;AArHE;EACE,gBAAA;EACA,SAAA;EACA,eAAA;EACA,UAAA;AAuHJ;AA1GI;EACE,yBAAA;AA4GN;;AA/FA;EACE,aAAA;EACA,mBAAA;AAkGF;;AA/FA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;AAkGF;;AA/FA;ED/ME,kCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;ACkTF;;AAnGA;EACE,cAAA;EACA,UAAA;EACA,SAAA;AAsGF;;AAnGA;EDxNE,kCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;ECuNA,mBAAA;EACA,2BAAA;EACA,WAAA;EACA,wCAAA;AAyGF;;AAtGA;EACE,+BAAA;EACA,mCAAA;EACA,uBAAA;AAyGF;;AApGA;EACE,aAAA;EACA,qBAAA;EACA,yBAAA;EACA,gBAAA;AAuGF;;AArGA;;ED9OE,kCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EC8OA,yBE7Qc;EF8Qd,mBAAA;AA2GF;;AAzGA;ED1PE,kCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;ECyPA,cElRc;AFiYhB;;AA7GA;EACE,gBAAA;EACA,QAAA;EACA,eAAA;AAgHF;;AA7GA;EACE,8BAAA;AAgHF;;AA9GA;EACE,8BAAA;AAiHF;;AA/GA;EACE,8BAAA;AAkHF;;AAhHA;EACE,8BAAA;AAmHF;;AAjHA;EACE,0BAAA;AAoHF;;AAlHA;EACE,UAAA;EACA,eAAA;EACA,gBAAA;EACA,sCAAA;AAqHF;;AAnHA;EACE;IACE,UAAA;EAsHF;EApHA;IACE,UAAA;EAsHF;AACF;AApHA;EACE,qBE7SY;EF8SZ,wCAAA;AAsHF;;AApHA;EACE;IACE,wBAAA;EAuHF;EArHA;IACE,0BAAA;EAuHF;EArHA;IACE,2BAAA;EAuHF;EArHA;IACE,0BAAA;EAuHF;EArHA;IACE,wBAAA;EAuHF;AACF;AApHA;EACE,yBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;AAsHF;;AAnHA;EACE,gBAAA;AAsHF;;AAnHA;EACE;IACE,YAAA;IACA,mBAAA;EAsHF;AACF;AApHA;EACE;IACE,YAAA;IACA,mBAAA;EAsHF;AACF;AAnHA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AAqHF;;AAlHA;EACE,WAAA;EACA,YAAA;EACA,oCAAA;EACA,uBAAA;EACA,kBAAA;EACA,kCAAA;AAqHF;;AAlHA;EACE,0CAAA;EACA,uBAAA;AAqHF;;AAlHA;EACE;IACE,yBAAA;EAqHF;AACF;AAlHA;EACE,iBAAA;EACA,eAAA;AAoHF;;AAjHA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;AAoHF;;AAlHA;EACE,oBAAA;EACA,cAAA;EACA,kBAAA;AAqHF;;AAnHA;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;AAsHF;;AApHA;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;AAuHF;;AArHA;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;AAwHF;;AAtHA;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;AAyHF;;AAvHA;EACE,cAAA;AA0HF;AAzHE;EACE,eAAA;EACA,eAAA;EACA,cE1bS;EF2bT,YAAA;AA2HJ;AA1HI;EACE,cEvbQ;AFmjBd;;AAvHA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AA0HF;;AAxHA;EACE,gBAAA;EACA,OAAA;EACA,sBAAA;EACA,UAAA;EACA,YAAA;AA2HF;;AAxHA;EACE,WAAA,EAAA,2BAAA;AA2HF;;AAxHA;EACE,WAAA,EAAA,2BAAA;AA2HF;;AAxHA;EDhcE,kCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EC+bA,eAAA;EACA,mBAAA;EACA,cEhec;EFied,0BAAA;EACA,eAAA;AA8HF;;AA3HA;EDzcE,kCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;ECwcA,aAAA;EACA,cE5da;EF6db,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EAEA,4EAAA;AAgIF;AA/HE;EACE,gBAAA;AAiIJ;;AA7HA;EDxdE,kCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;ECudA,aAAA;EACA,cE5eY;EF6eZ,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EAEA,4EAAA;AAkIF;;AA/HA;ED1eE,kCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;ECyeA,sBAAA;EACA,gBAAA;EACA,WEhgBM;EFigBN,eAAA;AAqIF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Abril+Fatface&family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap\");\r\n@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\r\n@font-face {\r\n  font-family: \"droid_sansbold\";\r\n  src: local(\"DroidSans-Bold-webfont.ttf\"),\r\n    url(\"../../assets/fonts/DroidSans-Bold-webfont.ttf\") format(\"truetype\");\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n@font-face {\r\n  font-family: \"droid_sansregular\";\r\n  src: local(\"DroidSans-webfont.ttf\"),\r\n    url(\"../../assets/fonts/DroidSans-webfont.ttf\") format(\"truetype\");\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n@mixin primeFont() {\r\n  font-family: \"Abril Fatface\", serif;\r\n  font-weight: 400;\r\n  font-style: normal;\r\n}\r\n@mixin secondaryFont() {\r\n  font-family: \"Poppins\", sans-serif;\r\n  font-optical-sizing: auto;\r\n  font-weight: 400;\r\n  font-style: normal;\r\n}\r\n@mixin secondaryFontBold() {\r\n  font-family: \"Poppins\", sans-serif;\r\n  font-optical-sizing: auto;\r\n  font-weight: 500;\r\n  font-style: normal;\r\n}\r\n","@import url(\"https://fonts.googleapis.com/css2?family=Abril+Fatface&family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n@font-face {\n  font-family: \"droid_sansbold\";\n  src: local(\"DroidSans-Bold-webfont.ttf\"), url(\"../../assets/fonts/DroidSans-Bold-webfont.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"droid_sansregular\";\n  src: local(\"DroidSans-webfont.ttf\"), url(\"../../assets/fonts/DroidSans-webfont.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n}\n\nul[role=list],\nol[role=list] {\n  list-style: none;\n}\n\nhtml:focus-within {\n  scroll-behavior: smooth;\n}\n\na:not([class]) {\n  text-decoration-skip-ink: auto;\n}\n\nimg,\npicture,\nsvg,\nvideo,\ncanvas {\n  max-width: 100%;\n  height: auto;\n  vertical-align: middle;\n  font-style: italic;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\ninput,\nbutton,\ntextarea,\nselect {\n  font: inherit;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  html:focus-within {\n    scroll-behavior: auto;\n  }\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n    scroll-behavior: auto !important;\n    transition: none;\n  }\n}\nbody,\nhtml {\n  height: 100%;\n  scroll-behavior: smooth;\n}\n\nbody {\n  font-family: \"Poppins\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 400;\n  font-style: normal;\n  -webkit-font-smoothing: antialiased;\n  margin: 0;\n  padding: 0;\n  background-color: #f4f6fa;\n  color: #2f2f2f;\n  font-size: 0.875rem;\n  --bs-body-font-size: 0.875rem;\n  line-height: 22px;\n}\n\nbutton:disabled,\ninput:disabled,\ntextarea:disabled,\nselect:disabled {\n  cursor: not-allowed !important;\n  opacity: 0.6 !important;\n}\n\np {\n  font-family: \"Poppins\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 400;\n  font-style: normal;\n  line-height: 1.25;\n  color: #2f2f2f;\n  margin-bottom: 1rem;\n}\n\ntable {\n  border: 1px solid #ebebeb;\n  border-radius: 0.5rem;\n  font-family: \"Poppins\", sans-serif;\n  font-size: 0.875rem;\n  color: #151515;\n}\n\ntable thead {\n  font-family: \"Poppins\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 500;\n  font-style: normal;\n  border-radius: 8px 8px 0 0;\n}\n\ntable tr td,\ntable tr th {\n  text-align: center;\n  padding: 0.6rem 0.5rem !important;\n  vertical-align: middle;\n}\n\nfieldset,\nlegend {\n  all: revert;\n  border-radius: 6px;\n  border-color: #bfbfbf;\n  background-color: #f5f7fb;\n  border-width: 1px;\n  padding: 0;\n}\n\nlegend {\n  font-family: \"Poppins\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 500;\n  font-style: normal;\n  background-color: transparent;\n  color: #0d47a0;\n  font-size: 1rem;\n  margin-left: 10px;\n  padding: 0 3px;\n}\n\ninput[type=checkbox] {\n  border: 1px solid #949494;\n  width: 18px;\n  height: 18px;\n}\n\n.success-color {\n  background-color: #339900;\n  color: #fff;\n  padding: 0 3px;\n  border-radius: 3px;\n}\n\n.warning-color {\n  background-color: #ed8b00;\n  color: #fff;\n  padding: 0 3px;\n  border-radius: 3px;\n}\n\n.danger-color {\n  background-color: #cc3201;\n  color: #fff;\n  padding: 0 3px;\n  border-radius: 3px;\n}\n\n.form-control:focus {\n  border-color: #9fa7b7;\n  box-shadow: none;\n}\n\n.btn {\n  font-family: \"Poppins\", sans-serif !important;\n  font-size: 14px !important;\n  font-weight: 600 !important;\n}\n\n.btn.btn-primary,\n.btn:active.btn-primary,\n.btn.active.btn-primary {\n  background-color: #0d47a0;\n}\n\n.btn.btn-primary:hover {\n  background-color: #093373;\n}\n\n.form-select {\n  font-family: \"Poppons\", sans-serif !important;\n  font-size: 14px !important;\n  line-height: 22px !important;\n}\n\n.form-label {\n  margin-bottom: 0.325rem;\n  font-size: 14px;\n  line-height: 18px;\n}\n\n.form-control {\n  border: 1px solid #e0e3e8;\n  width: 100%;\n  max-width: 250px;\n  height: 48px;\n  border-radius: 6px;\n  font-size: 14px;\n  line-height: 22px;\n  padding: 10px 12px;\n}\n\n.form-control.login-input-form {\n  max-width: 380px;\n}\n\n.form-select {\n  width: 100%;\n  max-width: 358px;\n}\n\n.red-border {\n  border-color: red !important;\n  border: 1px solid red !important;\n  color: red !important;\n}\n\n.green-border {\n  border-color: green !important;\n  border: 1px solid green !important;\n  color: green !important;\n}\n\n.btn-primary {\n  background-color: #0d47a0;\n  font-weight: bold;\n  transition: all 0.3s ease-in-out;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  white-space: nowrap;\n}\n.btn-primary:hover {\n  background-color: #093373;\n}\n\n.page-title {\n  font-family: \"Abril Fatface\", serif;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 2rem;\n  color: #0d47a0;\n  line-height: 2.5rem;\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.Select-input {\n  width: 330px;\n  height: 46px;\n  padding: 8px 12px;\n  border-radius: 0.5rem;\n  border: 1px solid #d3d3d3;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: linear-gradient(45deg, transparent 50%, gray 50%), linear-gradient(135deg, gray 50%, transparent 50%), linear-gradient(to right, #ccc, #ccc);\n  background-position: calc(100% - 20px) calc(1em + 6px), calc(100% - 15px) calc(1em + 6px), calc(100% - 2.5em) 0.9em;\n  background-size: 5px 5px, 5px 5px, 1px 1.5em;\n  background-repeat: no-repeat;\n}\n\n.footer-button {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  margin-top: 24px;\n  gap: 1rem;\n}\n\n.graph-title {\n  font-family: \"Poppins\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 500;\n  font-style: normal;\n  font-size: 0.875rem;\n  color: #2f2f2f;\n  padding: 0 1rem 1rem;\n  display: flex;\n  justify-content: center;\n}\n\n.table-responsive {\n  max-height: calc(100vh - 150px);\n  overflow: auto;\n}\n.table-responsive thead {\n  position: sticky;\n  top: -1px;\n  margin: 0 0 0 0;\n  z-index: 2;\n}\n.table-responsive thead th {\n  background-color: #f2f5f7;\n}\n\n.export-btn {\n  display: flex;\n  white-space: nowrap;\n}\n\n.export-share-btn-group {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.apexcharts-tooltip-title {\n  font-family: \"Poppins\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 500;\n  font-style: normal;\n}\n\n.childrenContainer {\n  display: block;\n  padding: 0;\n  margin: 0;\n}\n\n#tooltip-top > .tooltip-inner {\n  font-family: \"Poppins\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 500;\n  font-style: normal;\n  font-size: 0.875rem;\n  background: rgb(9, 51, 115);\n  color: #fff;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);\n}\n\n.tooltip-container {\n  --bs-tooltip-bg: $primary-color;\n  --bs-emphasis-color: $primary-color;\n  --bs-tooltip-opacity: 1;\n}\n\n.pagination-container {\n  display: flex;\n  align-items: baseline;\n  justify-content: flex-end;\n  margin-top: 1rem;\n}\n\n.page-link.active,\n.active > .page-link {\n  font-family: \"Poppins\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 500;\n  font-style: normal;\n  background-color: #0d47a0;\n  font-size: 0.875rem;\n}\n\n.page-link {\n  font-family: \"Poppins\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 400;\n  font-style: normal;\n  color: #0d47a0;\n}\n\nTable thead {\n  position: sticky;\n  top: 0px;\n  margin: 0 0 0 0;\n}\n\n.blue-color {\n  border-left: 3px solid #0d6efd;\n}\n\n.green-color {\n  border-left: 3px solid #008085;\n}\n\n.purple-color {\n  border-left: 3px solid #7952b3;\n}\n\n.orange-color {\n  border-left: 3px solid #ff8225;\n}\n\n.c-pointer {\n  cursor: pointer !important;\n}\n\n.error-text {\n  color: red;\n  font-size: 13px;\n  line-height: 1.2;\n  animation: showErrors 0.5s ease-in-out;\n}\n\n@keyframes showErrors {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n.error-border {\n  border-color: #cc3201;\n  animation: horizontal-shaking 0.35s ease;\n}\n\n@keyframes horizontal-shaking {\n  0% {\n    transform: translateX(0);\n  }\n  25% {\n    transform: translateX(5px);\n  }\n  50% {\n    transform: translateX(-5px);\n  }\n  75% {\n    transform: translateX(5px);\n  }\n  100% {\n    transform: translateX(0);\n  }\n}\n.form-input {\n  border: 1px solid #c2c2c2;\n  box-shadow: none;\n  padding: 10px 4px;\n  border-radius: 6px;\n  width: 100px;\n}\n\n.modal-body {\n  overflow-x: auto;\n}\n\n@media (max-width: 767px) {\n  .form-label {\n    width: 150px;\n    white-space: nowrap;\n  }\n}\n@media (min-width: 768px) and (max-width: 1180px) {\n  .form-label {\n    width: 150px;\n    white-space: nowrap;\n  }\n}\n.loader-container-sm {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100px;\n}\n\n.loader-sm {\n  width: 24px;\n  height: 24px;\n  border: 4px solid rgba(0, 0, 0, 0.1);\n  border-left-color: #000;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n.loader-color-white {\n  border: 4px solid rgba(255, 255, 255, 0.1);\n  border-left-color: #fff;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n.loader-text {\n  margin-left: 10px;\n  font-size: 14px;\n}\n\n.legend {\n  display: flex;\n  gap: 2rem;\n  flex-flow: row wrap;\n  margin-bottom: 0.5rem;\n  padding-left: 0;\n}\n\n.legend li {\n  padding-left: 1.5rem;\n  display: block;\n  position: relative;\n}\n\n.legend li:nth-child(1)::before {\n  content: \"\";\n  width: 16px;\n  height: 16px;\n  background-color: #2a61dd;\n  position: absolute;\n  border-radius: 50%;\n  top: 15%;\n  left: 0;\n}\n\n.legend li:nth-child(2)::before {\n  content: \"\";\n  width: 16px;\n  height: 16px;\n  background-color: #279e70;\n  position: absolute;\n  border-radius: 50%;\n  top: 15%;\n  left: 0;\n}\n\n.legend li:nth-child(3)::before {\n  content: \"\";\n  width: 16px;\n  height: 16px;\n  background-color: #ff9800;\n  position: absolute;\n  border-radius: 50%;\n  top: 15%;\n  left: 0;\n}\n\n.legend li:nth-child(4)::before {\n  content: \"\";\n  width: 16px;\n  height: 16px;\n  background-color: #c82519;\n  position: absolute;\n  border-radius: 50%;\n  top: 15%;\n  left: 0;\n}\n\n.actionITems {\n  display: block;\n}\n.actionITems .action-item-icon {\n  cursor: pointer;\n  font-size: 22px;\n  color: #2f2f2f;\n  padding: 3px;\n}\n.actionITems .action-item-icon:hover {\n  color: #cc3201;\n}\n\n.thead-align {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n.sticky-col {\n  position: sticky;\n  left: 0;\n  background-color: #fff;\n  z-index: 1;\n  width: 150px;\n}\n\n.sticky-col:nth-child(2) {\n  left: 150px; /* Adjust width as needed */\n}\n\n.sticky-col:nth-child(3) {\n  left: 300px; /* Adjust width as needed */\n}\n\n.btn-text {\n  font-family: \"Poppins\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 500;\n  font-style: normal;\n  display: inline;\n  font-size: 0.825rem;\n  color: #0d47a0;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.success-message {\n  font-family: \"Poppins\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 500;\n  font-style: normal;\n  display: flex;\n  color: #339900;\n  padding: 6px 12px;\n  background-color: #fff;\n  border: 1px solid #339900;\n  border-radius: 6px;\n  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;\n}\n.success-message h4 {\n  margin-bottom: 0;\n}\n\n.error-message {\n  font-family: \"Poppins\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 500;\n  font-style: normal;\n  display: flex;\n  color: #cc3201;\n  padding: 6px 12px;\n  background-color: #fff;\n  border: 1px solid #cc3201;\n  border-radius: 6px;\n  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;\n}\n\n.close-button {\n  font-family: \"Poppins\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 400;\n  font-style: normal;\n  background-color: #333;\n  padding: 4px 6px;\n  color: #fff;\n  font-size: 1rem;\n}","*,\r\n*::before,\r\n*::after {\r\n  box-sizing: border-box;\r\n}\r\n\r\n* {\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\nul[role=\"list\"],\r\nol[role=\"list\"] {\r\n  list-style: none;\r\n}\r\n\r\nhtml:focus-within {\r\n  scroll-behavior: smooth;\r\n}\r\n\r\na:not([class]) {\r\n  text-decoration-skip-ink: auto;\r\n}\r\n\r\nimg,\r\npicture,\r\nsvg,\r\nvideo,\r\ncanvas {\r\n  max-width: 100%;\r\n  height: auto;\r\n  vertical-align: middle;\r\n  font-style: italic;\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n}\r\n\r\ninput,\r\nbutton,\r\ntextarea,\r\nselect {\r\n  font: inherit;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  html:focus-within {\r\n    scroll-behavior: auto;\r\n  }\r\n  *,\r\n  *::before,\r\n  *::after {\r\n    animation-duration: 0.01ms !important;\r\n    animation-iteration-count: 1 !important;\r\n    transition-duration: 0.01ms !important;\r\n    scroll-behavior: auto !important;\r\n    transition: none;\r\n  }\r\n}\r\n\r\nbody,\r\nhtml {\r\n  height: 100%;\r\n  scroll-behavior: smooth;\r\n}\r\n","$primary-color: #0d47a0;\r\n$primary-color-hover: #093373;\r\n$secondary-blue: #93cfff;\r\n$background-color: #f4f6fa;\r\n$white: #fff;\r\n$text-color: #2f2f2f;\r\n$text-dark-color: #072148;\r\n$table-stroke-color: #dfdfdf;\r\n$stroke-color: #949494;\r\n$input-stroke: #e4e8e9;\r\n$text-warning: #ed8b00;\r\n$text-danger: #cc3201;\r\n$text-success: #339900;\r\n$tooltip-bg: #0d47a0;\r\n$tooltip-color: #ffffff;\r\n$button-color: #ff6b00;\r\n","@import \"variables\", \"colors\", \"fonts\", \"reset\";\r\n\r\n@mixin boxWithShadow() {\r\n  background-color: $white;\r\n  border-radius: 0.5rem;\r\n  box-shadow: 0 0 20px rgba(0, 0, 0, 13%);\r\n}\r\n@mixin brandScores() {\r\n  background-color: $white;\r\n  border-radius: 0.5rem;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 12%);\r\n  padding: 0.675rem;\r\n}\r\n\r\n@mixin pageTitle() {\r\n  @include primeFont();\r\n  font-size: 2rem;\r\n  color: $primary-color;\r\n  line-height: 2.5rem;\r\n  margin-top: 0.5rem;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n@mixin boxSubTitle() {\r\n  @include secondaryFontBold;\r\n  font-size: 1rem;\r\n  color: $text-color;\r\n  line-height: 1.2;\r\n  margin-bottom: .875rem;\r\n  display: flex;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
